import { ReactComponent as ChevronDownIcon } from "components/Icons/chevron-down.svg";
import { Tooltip } from "components/Tooltips/Tooltip";
import { useIsOverflown } from "hooks/useIsOverflown";
import { useState } from "react";
import { Attribute } from "./AttributesDetails";
import { useStyles } from "./styles";
import { countObject } from "./utils";

interface Props {
  attribute: {
    name: string;
    value?: string | number | Attribute | Attribute[];
  };
}

const renderAttributes = (
  values?: string | number | Attribute | Attribute[],
) => {
  switch (typeof values) {
    case "number":
    case "string":
      return null;
    case "object":
      const isArray = Array.isArray(values);

      if (isArray) {
        return values.map((attribute) => {
          const isComplexAttribute = typeof attribute === "object";

          return !isComplexAttribute ? (
            <li>
              <ComplexAttribute
                attribute={{
                  name: attribute,
                }}
              />
            </li>
          ) : (
            Object.keys(attribute).map((attr, index) => (
              <li>
                <ComplexAttribute
                  attribute={{
                    name: attr,
                    value: attribute[attr],
                  }}
                />
              </li>
            ))
          );
        });
      }
      return Object.keys(values).map((attr, index) => (
        <li>
          <ComplexAttribute
            attribute={{
              name: attr,
              value: values[attr],
            }}
          />
        </li>
      ));
  }
};

export const ComplexAttribute = ({ attribute }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyles();
  const isComplexAttribute = typeof attribute.value === "object";
  const objectCount = countObject(attribute.value);
  const areAnyObjects = objectCount > 0;
  const { observeElement, isOverflown } = useIsOverflown();

  return (
    <>
      <div className={classes.wrapper}>
        <div className={classes.content}>
          <div>&nbsp;</div>
          {isComplexAttribute && areAnyObjects && (
            <ChevronDownIcon
              className={`${classes.icon} ${isOpen ? classes.rotate : ""}`}
            />
          )}
          <Tooltip
            text={
              <span>
                {attribute.name}
                {!isComplexAttribute ? (
                  `: ${attribute.value}`
                ) : (
                  <div className={classes.objectsCount}>{objectCount}</div>
                )}
              </span>
            }
            disableHoverListener={!isOverflown}
            placement="bottom-start"
          >
            <div
              className={classes.chips}
              onClick={
                isComplexAttribute && areAnyObjects
                  ? () => setIsOpen(!isOpen)
                  : undefined
              }
              ref={observeElement}
            >
              {attribute.name}
              {!isComplexAttribute ? (
                `: ${attribute.value}`
              ) : (
                <div className={classes.objectsCount}>{objectCount}</div>
              )}
            </div>
          </Tooltip>
        </div>
      </div>
      {isOpen && (
        <ol className={classes.attrChild}>
          {renderAttributes(attribute.value)}
        </ol>
      )}
    </>
  );
};
